export default __webpack_public_path__ + "static/media/G0860.Breech_semir_handing2.1692873900000.c4eab36b.jpg";